import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { NlpIntent } from './components';

const NlpList = ({ match }) => {
  return <NlpIntent agentId={match.params.agentId} />;
};
const routes = () => (
  <PrivateRoute
    exact
    path="/nlp/intent/:agentId"
    component={NlpList}
  />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/NlpIntenet/routes.js